import { histogramPlot, periodInput } from "../definitionHelpers";
import { COLOR_RULE } from "../indicatorTypes";

/**
 * Momentum (research §1.4), as TV Momentum: the close minus the close
 * Period bars ago (in prices, so the pane keeps the pair precision); no
 * value where that close is missing or zero, as in TV. Drawn as in PO: a
 * histogram, a column is up when higher than the previous one.
 */
export default {
  id: "momentum",
  name: "Momentum",
  isOscillator: true,
  inputs: [
    periodInput("period", "Period", 10),
  ],
  plots: [
    histogramPlot("value", "Main Line", COLOR_RULE.TREND),
  ],
  levels: [],

  calculate: (bars, { period }, series, fromIndex) => {
    for (let index = fromIndex; index < bars.length; index += 1) {
      const pastClose = index >= period ? bars[index - period].close : NaN;

      series.value[index] = pastClose ? bars[index].close - pastClose : NaN;
    }
  },
};
